<div class="fleet-management-preview"
     [class.device-desktop]="deviceType === 'desktop'"
     [class.device-tablet]="deviceType === 'tablet'"
     [class.device-mobile]="deviceType === 'mobile'"
     [class.page-loaded]="isPageLoaded"
     [style.background-color]="getPageHeaderSectionBackgroundColor()">
  <!-- Page Title Section (contains header inside) - matching express wash packages structure -->
  <section 
    class="page-title-section website-element fleets-hero-element" 
    *ngIf="isSectionVisible('hero_section')"
    [class.selected]="getHeroSectionElement()?.selected"
    [style.background]="getHeroBackground()">
    
    <!-- Header Section inside Page Title Section -->
    <div class="page-title-header-wrapper" (click)="onHeaderClick($event)">
      <div class="website-element header-element" 
           *ngIf="isSectionVisible('header')"
           [class.selected]="getHeaderElement()?.selected">
        <app-champs-page-header
          [logo]="getHeaderLogo()"
          [navigation]="getHeaderNavigation()"
          [ctaButton]="getHeaderCTAButton()"
          [visible]="true"
          [clickable]="true"
          [selected]="getHeaderElement()?.selected || false"
          [headingColor]="headingColor"
          [headingFont]="headingFont"
          [backgroundColor]="getHeaderBackgroundColor()"
          [deviceType]="deviceType"
          (navigationClick)="onNavigationClick($event)">
        </app-champs-page-header>
      </div>
    </div>

    <!-- Hero Content -->
    <div class="hero-container" (click)="onHeroSectionClick($event)">
      <h1 class="hero-title"
          [style.color]="getHeroTitleColor()"
            [style.font-family]="getHeadingFont()"
          [ngStyle]="getHeroTitleStyles()">
        {{ getHeroTitle() }}
      </h1>
      <p class="hero-subtitle"
         [style.color]="getHeroSubtitleColor()"
         [style.font-family]="getBodyFont()"
         [ngStyle]="getHeroSubtitleStyles()">
        {{ getHeroSubtitle() }}
      </p>
      <div class="hero-image-wrapper" *ngIf="getHeroImage()">
        <img [src]="getHeroImage()" 
             [alt]="getHeroImageAlt()"
             class="hero-image">
      </div>
    </div>
  </section>

  <!-- Form Section -->
  <section 
    class="form-section website-element fleets-form-element" 
    *ngIf="isSectionVisible('form_section')"
    [class.selected]="getFleetSectionElement()?.selected"
    (click)="onFormSectionClick($event)">
    <div class="form-container">
      <form class="fleet-form" (ngSubmit)="onSubmit()">
        <!-- Row 1: Company Name and Your Name -->
        <div class="form-row">
          <div class="form-group">
            <label for="company_name" class="form-label">Company Name</label>
            <input 
              type="text" 
              id="company_name"
              name="company_name"
              class="form-input"
              placeholder="eg. Ema"
              [(ngModel)]="formData.company_name"
              required>
          </div>
          <div class="form-group">
            <label for="contact_name" class="form-label">Your Name</label>
            <input 
              type="text" 
              id="contact_name"
              name="contact_name"
              class="form-input"
              placeholder="John Smith"
              [(ngModel)]="formData.contact_name"
              required>
          </div>
        </div>

        <!-- Row 2: Phone Number and Email -->
        <div class="form-row">
          <div class="form-group">
            <label for="phone" class="form-label">Phone Number</label>
            <input 
              type="tel" 
              id="phone"
              name="phone"
              class="form-input"
              placeholder="(123) 456-7890"
              [(ngModel)]="formData.phone"
              required>
          </div>
          <div class="form-group">
            <label for="email" class="form-label">Email</label>
            <input 
              type="email" 
              id="email"
              name="email"
              class="form-input"
              placeholder="john@example.com"
              [(ngModel)]="formData.email"
              required>
          </div>
        </div>

        <!-- Row 3: Wash Type and No of Vehicle -->
        <div class="form-row">
          <div class="form-group">
            <label for="wash_type" class="form-label">Wash Type</label>
            <input 
              type="hidden"
              name="wash_type"
              [(ngModel)]="formData.wash_type"
              required>
            <div class="dropdown-wrapper" (click)="$event.stopPropagation()">
              <div class="dropdown-input" [class.dropdown-open]="showWashTypeDropdown" (click)="toggleWashTypeDropdown($event)">
                <span class="dropdown-text" [class.placeholder]="!formData.wash_type">
                  {{ getSelectedWashTypeName() }}
                </span>
                <svg class="dropdown-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M3.5 5.5L7 9L10.5 5.5" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="dropdown-menu" *ngIf="showWashTypeDropdown" (click)="$event.stopPropagation()">
                <div 
                  class="dropdown-item" 
                  *ngFor="let package of packages; trackBy: trackById"
                  (click)="selectWashType(package.package_name, $event)"
                >
                  {{ package.package_name }}
                </div>
                <div class="dropdown-item" *ngIf="loading">Loading packages...</div>
                <div class="dropdown-item" *ngIf="!loading && packages.length === 0">No packages available</div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="vehicle_count" class="form-label">No of Vehicle</label>
            <input 
              type="number" 
              id="vehicle_count"
              name="vehicle_count"
              class="form-input"
              placeholder="eg. 20"
              [(ngModel)]="formData.vehicle_count"
              min="1"
              required>
          </div>
        </div>

        <!-- Row 4: Location -->
        <div class="form-row">
          <div class="form-group">
            <label for="location" class="form-label">Location *</label>
            <input 
              type="hidden"
              name="location"
              [(ngModel)]="formData.location"
              required>
            <div class="dropdown-wrapper" (click)="$event.stopPropagation()">
              <div class="dropdown-input" [class.dropdown-open]="showLocationDropdown" [class.disabled]="isLoadingLocations || locations.length === 0" (click)="toggleLocationDropdown($event)">
                <span class="dropdown-text" [class.placeholder]="!formData.location">
                  {{ getSelectedLocationName() }}
                </span>
                <svg class="dropdown-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M3.5 5.5L7 9L10.5 5.5" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="dropdown-menu" *ngIf="showLocationDropdown" (click)="$event.stopPropagation()">
                <div 
                  class="dropdown-item" 
                  *ngFor="let location of locations; trackBy: trackById"
                  (click)="selectLocation(location.id, $event)"
                >
                  {{ location.name }}
                </div>
                <div class="dropdown-item" *ngIf="isLoadingLocations">Loading locations...</div>
                <div class="dropdown-item" *ngIf="!isLoadingLocations && locations.length === 0">
                  {{ locationsError || 'No locations available' }}
                </div>
              </div>
            </div>
            <div *ngIf="!isLoadingLocations && (locations.length === 0 || locationsError)" class="error-text" style="font-size: 12px; color: #EF4444; margin-top: 4px;">
              {{ locationsError || 'No locations found.' }}
            </div>
          </div>
        </div>

        <!-- Row 5: Special Requests (Full Width) -->
        <div class="form-group form-group-full">
          <label for="notes" class="form-label">Special Requests or Notes</label>
          <textarea 
            id="notes"
            name="notes"
            class="form-textarea"
            placeholder="Any special requests or vehicle details."
            [(ngModel)]="formData.notes"
            rows="5"></textarea>
        </div>

        <!-- Submit Button -->
        <button type="submit" class="submit-button"
                [style.background-color]="getPrimaryColor()"
                [style.color]="getHeadingColor()"
                [disabled]="submitting">
          <span *ngIf="!submitting">{{ getButtonText() }}</span>
          <span *ngIf="submitting">Submitting...</span>
        </button>
      </form>
    </div>
  </section>

  <!-- Footer -->
  <!-- Footer -->
  <div class="website-element footer-element" 
       *ngIf="isSectionVisible('footer')"
       [class.selected]="getFooterElement()?.selected"
       (click)="onFooterClick($event)">
    <app-champs-page-footer 
      [quickLinks]="getFooterQuickLinks()"
      (quickLinkClick)="onNavigationClick($event)"
      [quickLinksTitle]="getFooterQuickLinksTitle()"
      [socialLinks]="getFooterSocialLinks()"
      [socialLinksTitle]="getFooterSocialLinksTitle()"
      [copyright]="getFooterCopyright()"
      [logo]="getFooterLogo()"
      [deviceType]="deviceType"
      [backgroundColor]="getFooterBackgroundColor()">
    </app-champs-page-footer>
  </div>
</div>

